<template>
  <div class="order-container">
    <div class="order-actions">

      <div class="actions-compact">
        <!-- Перший ряд - 3 кнопки -->
        <div class="action-row">

          <button class="btn btn-outline-secondary btn-compact"
            :disabled="(this.details.length < 1) || loading || !is1cConnected" @click="checkDetails">
            <i class="fa fa-check-circle"></i>
            Перевірити
          </button>
          <button :disabled="(this.details.length < 1) || loading || !is1cConnected" @click="calcOrder"
            class="btn btn-info btn-compact">
            <i class="fa fa-calculator"></i>
            Розрахунок
          </button>
          <button :disabled="(this.details.length < 1) || loading || !is1cConnected" @click="toWork"
            class="btn btn-primary btn-compact">
            <i class="fa fa-shopping-cart"></i>
            Замовити
          </button>

        </div>

        <!-- Другий ряд - 3 кнопки -->
        <div class="action-row">
          <button :disabled="(this.details.length < 1) || loading || !is1cConnected"
            class="btn btn-outline-secondary btn-compact" @click="drawCut">
            <i class="fa fa-cut"></i>
            Карти крою
          </button>
          <button @click="saveDraft" :disabled="(this.details.length === 0) || loading"
            class="btn btn-success btn-compact">
            <i class="fa fa-save"></i>
            Зберегти
          </button>
          <button class="btn btn-outline-danger btn-compact" :disabled="(this.details.length === 0) || loading"
            @click="clearB">
            <i class="fa fa-trash-alt"></i>
            Очистити
          </button>
        </div>
      </div>
      <div v-if="!is1cConnected && connectionText" class="connection-status">
        <i class="fa fa-plug"></i>
        <span>{{ connectionText }}</span>
      </div>
    </div>
    <file-modal :pdfExists="pdfFile.exists" :pdfFile="pdfFile.path" />

  </div>
</template>

<script>
import axios from 'axios';
import appconfig from "../app/config";
import moment from 'moment';
import FileModal from "@/components/modals/pdfModal";
import $ from "jquery";

export default {
  name: "order",
  components: {
    moment, FileModal
  },
  data() {
    return {
      loading: false,
      check_parts: false,
      pdfFile: {
        path: "",
        exists: false,
      },
      order: {
        "readonly": false,
        "dept": '',
        "section": '',
        "customer": '',
        "stock": '',
        "cy": '',
        "manager": '',
        "price_type": '',
        "comment": "",
        "date_sale": moment().add(1, 'day').format('YYYY-MM-DDTHH:mm:ss'),
        "glue": false,
        "edge_size": false,
        "customer_edge": false,
        "customer_material": false,
        "to_work": false,
        "draw_cut": false,
        "check_parts": false,
        "materials_list": [],
        "edge_list": [],
        "screed_list": [],
        "name_list": [],
        "items": [],
      },
      resp: app.response,
      sum: 0,
      client: this.$store.state.auth.user,
      connection: {
        connected: true,
        text: '',
        checkedAt: null
      },
      connectionIntervalId: null
    }
  },
  computed: {
    details: {
      get() {
        return this.$store.state.data.details;
      },
      set(val) {
        return this.$store.commit('data/SET_DETAILS', val);
      },
    },
    detail() {
      return this.$store.state.data.detail;
    },
    settings() {
      return this.$store.state.auth.settings;
    },
    is1cConnected() {
      return this.connection.connected === true;
    },
    connectionText() {
      return this.connection.text || '';
    }
  },
  watch: {
    '$route': 'fetchData',
    loading(val) {
      if (val) {
        document.querySelector('body').classList.add('loading');
      } else {
        document.querySelector('body').classList.remove('loading');
      }
    }
  },
  methods: {
    async fetch1cConnection() {
      try {
        const response = await axios.get(appconfig.Point + 'api/constructor/v1/1c/connection');
        const data = response.data || {};
        this.connection.connected = !!data.connected;
        this.connection.text = data.text || '';
        this.connection.checkedAt = data.checked_at || null;
      } catch (e) {
        this.connection.connected = false;
        this.connection.text = '';
        this.connection.checkedAt = null;
      }
    },
    getDefault(settingKey = null) {
      let settings = this.$store.state.auth.settings;
      if (settingKey && settings && settings[settingKey] !== undefined) return settings[settingKey];
      return false;
    },
    processDetailsNo() {
      this.details = this.details.map((detail, index) => {
        detail.No = index + 1;
        return detail;
      })
    },
    saveDraft() {

      if (document.getElementById('detailTableForm').reportValidity() === false) {
        return false;
      }
      this.loading = true;
      this.$toast.info("Зберігаємо...");
      this.order.draft = 1;
      this.saveOrder();
    },
    calcOrder() {
      if (document.getElementById('detailTableForm').reportValidity() === false) {
        return false;
      }
      this.$toast.info("Вже рахуємо")
      this.loading = true;
      axios.post(
        appconfig.Point + 'api/constructor/v1/order/calculate',
        this.getOrderObject()
      ).then(response => {
        response = response.data;
        this.$store.commit('data/SET_RESPONSE_DEBUG', response)
        this.$store.commit('data/SET_RESPONSE', response);
        if (response.Error == true) {
          if (typeof response.ErrorMsg != 'undefined') {
            this.$toast.error(response.ErrorMsg)
          } else {
            this.$toast.error("У деталіровці знайдені помилки! Зверніть увагу на червоні виділення полів, при наведенні на які буде показано правильний варіант.")
          }
        } else {
          document.querySelector('#orderModalBtn').click();
        }
        this.loading = false;
      }).catch(r => {
        this.$toast.error("Щось пішло не так")
        this.loading = false;
      })
    },
    async toWork() {
      if (document.getElementById('detailTableForm').reportValidity() === false) {
        return false;
      }
      this.loading = true;
      let orderId = this.order.id;
      this.$toast.info("Працюємо з замовленням")
      if (!this.order.id) {
        let url = 'api/constructor/v1/order/create';
        let res = await axios.post(
          appconfig.Point + url,
          this.convertToFormData(this.getOrderObject()),
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        orderId = res.data.order.id;
      } else {
        await axios.post(
          appconfig.Point + 'api/constructor/v1/order/update/' + this.order.id,
          this.convertToFormData(this.getOrderObject()),
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
      }
      this.$toast.info("Запит у систему обліку")
      let response = await axios.get(
        appconfig.Point + 'api/constructor/v1/order/work/' + orderId,
        this.getOrderObject()
      );
      response = response.data;
      this.order = response.order;
      this.$store.commit('data/SET_RESPONSE_DEBUG', response)
      this.$store.commit('data/SET_RESPONSE', response['1c']);
      this.$store.commit('data/SET_ORDER', this.order);
      if (response['1c'].Error == true) {
        if (typeof response['1c'].ErrorMsg != 'undefined') {
          this.$toast.error(response['1c'].ErrorMsg)
        } else {
          this.$toast.error("У деталіровці знайдені помилки! Зверніть увагу на червоні виділення полів.")
        }
      } else {
        this.$toast.success("Замовлення створено")
        document.querySelector('#orderModalBtn').click();
      }
      this.loading = false;
    },
    drawCut() {
      if (document.getElementById('detailTableForm').reportValidity() === false) {
        return false;
      }
      this.loading = true;
      this.order.draw_cut = true;
      this.getDrawCut();
    },
    checkDetails() {
      if (document.getElementById('detailTableForm').reportValidity() === false) {
        return false;
      }
      this.loading = true;
      this.order.check_parts = true;
      this.validateOrder();
    },
    getDrawCut() {

      this.$toast.info('Малюємо карту крою')
      axios.post(
        appconfig.Point + 'api/constructor/v1/order/draw-cut',
        this.getOrderObject()
      ).then(response => {
        response = response.data;
        if (response.Error == true) {
          this.$store.commit('data/SET_RESPONSE_DEBUG', response)
          this.$store.commit('data/SET_RESPONSE', response);
          if (typeof response.ErrorMsg != 'undefined') {
            this.$toast.error(response.ErrorMsg)
          } else {
            this.$toast.error("У деталіровці знайдені помилки! Зверніть увагу на червоні виділення полів, при наведенні на які буде показано правильний варіант.")
          }
        } else {
          this.pdfFile.path = response.pdf;
          this.pdfFile.exists = true;
          this.$bvModal.show('fileModal')
        }
        this.loading = false;
      }).then(r => {
        this.loading = false;
      })
    },
    validateOrder() {
      this.$toast.info("Запит у систему обліку")
      axios.post(
        appconfig.Point + 'api/constructor/v1/order/validate',
        this.getOrderObject()
      ).then(response => {
        response = response.data;
        this.$store.commit('data/SET_RESPONSE_DEBUG', response)
        this.$store.commit('data/SET_RESPONSE', response);
        if (response.Error == true) {
          if (typeof response.ErrorMsg != 'undefined') {
            this.$toast.error(response.ErrorMsg)
          } else {
            this.$toast.error("У деталіровці знайдені помилки! Зверніть увагу на червоні виділення полів, при наведенні на які буде показано правильний варіант.")
          }
        } else {
          this.$toast.success('Помилок не знайдено!')
        }
      }).then(r => {
        this.loading = false;
      })
    },
    saveOrder() {

      let url = 'api/constructor/v1/order/create';
      if (this.order.id != null) {
        url = 'api/constructor/v1/order/update/' + this.order.id;
      }
      axios.post(
        appconfig.Point + url,
        this.convertToFormData(this.getOrderObject()),
        { headers: { 'Content-Type': 'multipart/form-data' } }
      ).then(response => {
        this.$store.commit('data/SET_RESPONSE_DEBUG', response.data)
        this.$toast.success("Успішно збережено");
        if (this.order.draft == 1) {
          this.order = response.data.order;
          this.$store.commit('data/SET_ORDER', this.order);
        }
      }).then(r => {
        this.loading = false;
      }).catch(e => {
        this.loading = false;
        this.$toast.error("Щось пішло не так =(");
      })
    },
    clear() {
      this.clearB(false)
    },
    clearB(confirmAlert = true) {
      if (confirmAlert && !confirm('Ви впевнені?')) {
        return;
      }
      this.order = {
        "readonly": false,
        "dept": '',
        "doc_no": '',
        "section": '',
        "customer": '',
        "stock": '',
        "cy": '',
        "manager": '',
        "price_type": '',
        "comment": "",
        "date_sale": moment().add(1, 'day').format('YYYY-MM-DDTHH:mm:ss'),
        "glue": false,
        "edge_size": this.getDefault('with_edge_sizes'),
        "customer_edge": false,
        "customer_material": false,
        "to_work": false,
        "draw_cut": false,
        "check_parts": false,
        "materials_list": [],
        "edge_list": [],
        "screed_list": [],
        "name_list": [],
        "items": [],
      };
      this.$store.commit('data/SET_DETAILS', []);
      this.$store.commit('data/SET_MATERIALS', []);
      this.$store.commit('data/SET_EDGES', []);
      this.$store.commit('data/SET_SCREEDS', []);
      this.$store.commit('data/SET_NAMES', []);
      this.$store.commit('data/SET_DETAIL', {});
      this.$store.commit('data/SET_ORDER', this.order);

    },
    convertToFormData(obj, formData = new FormData(), parentKey = '') {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = obj[key];
          const formKey = parentKey ? `${parentKey}[${key}]` : key;

          if (value === null || value === undefined) {
            // Заменяем null/undefined на пустую строку
            formData.append(formKey, '');
          } else if (value instanceof File) {
            // Файлы добавляем как есть
            formData.append(formKey, value);
          } else if (Array.isArray(value)) {
            // Массивы обрабатываем рекурсивно
            value.forEach((item, index) => {
              if (typeof item === 'object' && item !== null) {
                this.convertToFormData(item, formData, `${formKey}[${index}]`);
              } else {
                formData.append(`${formKey}[${index}]`, item === null ? '' : item);
              }
            });
          } else if (typeof value === 'object' && !(value instanceof Date)) {
            // Вложенные объекты обрабатываем рекурсивно
            this.convertToFormData(value, formData, formKey);
          } else {
            // Примитивы добавляем как есть
            formData.append(formKey, value);
          }
        }
      }
      return formData;
    },
    getOrderObject() {
      this.$store.commit('data/SET_RESPONSE', null);
      this.processDetailsNo();

      const { user } = this.$store.state.auth;
      const { materials, edges, screeds, detailsNames } = this.$store.state.data;
      const production_params = user.client.production_params[0];
      const defaultMaterial = this.$store.getters['data/defaultMaterial'];
      const defaultEdge = this.$store.getters['data/defaultEdge'];

      const cli = {
        dept: "ТПМ",
        section: production_params.section,
        customer: user.client.ref,
        stock: user.defaultStock,
        cy: "980",
        manager: production_params.manager,
        price_type: production_params.price_type,
        draw_cut: this.order.draw_cut,
        to_work: this.order.to_work,
        check_parts: this.order.check_parts,
        comment: this.order.comment,
        screed_list: screeds.length ? screeds : [],
        name_list: detailsNames.length ? detailsNames : [],
      };
      let orderStore = this.$store.getters['data/order']

      this.order = {
        ...this.order,
        customer_material: orderStore.customer_material,
        customer_edge: orderStore.customer_edge,
        edge_size: orderStore.edge_size,
        date_sale: orderStore.date_sale,
        glue: orderStore.glue,
        items: this.details,
        check_parts: this.check_parts,
      };

      return {
        ...this.order,
        ...cli,
        materials_list: materials.map(item => {
          return {
            ref: item.ref,
            color: item.color,
            default: item.ref === defaultMaterial?.ref
          }
        }),
        edge_list: edges.map(item => {
          return {
            ref: item.ref,
            color: item.color,
            default: item.ref === defaultEdge?.ref
          }
        }),
      };
    },
    loadOrder(id) {
      axios.get(
        appconfig.Point + 'api/constructor/v1/order/view/' + id
      )
        .then(response => {
          this.loading = false;
          this.order = {
            ...response.data.data,
            ...{
              doc: '',
              doc_no: '',
              date_ready: '',
              id: response.data.data.doc_no == null ? response.data.data.id : null,
              date_sale: moment().add(1, 'day').format('YYYY-MM-DDTHH:mm:ss'),
              "to_work": false,
              "draw_cut": false,
              "check_parts": false,
            }
          };

          this.$store.dispatch('data/resetModule');
          this.$store.commit('data/SET_ORDER', this.order);
          this.$store.commit('data/SET_DETAILS', response.data.data.items);
          this.$store.commit('data/SET_MATERIALS', response.data.data.materials_list);
          this.$store.commit('data/SET_EDGES', response.data.data.edge_list);
          this.$store.commit('data/SET_SCREEDS', response.data.data.screed_list || []);
          this.$store.commit('data/SET_NAMES', response.data.data.name_list || []);
          this.$store.commit('data/SET_DETAIL', response.data.data.items[0]);
          if (response.data.data.materials_list.length > 0 && response.data.data.materials_list.some(item => item.is_default)) {
            this.$store.commit('data/SET_DEFAULT_MATERIALS', response.data.data.materials_list.find(item => item.is_default));
          }
          if (response.data.data.edge_list.length > 0 && response.data.data.edge_list.some(item => item.is_default)) {
            this.$store.commit('data/SET_DEFAULT_EDGES', response.data.data.edge_list.find(item => item.is_default));
          }

        })
        .then(r => {
          this.loading = false;
        })
    },
    fetchData() {
      this.$store.commit('data/SET_RESPONSE', null)
      if (this.$route.params.id) {
        this.loading = true;
        this.loadOrder(this.$route.params.id);
      } else {
        this.order = {
          "id": null,
          "dept": '',
          "doc_no": '',
          "section": '',
          "customer": '',
          "stock": '',
          "cy": '',
          "manager": '',
          "price_type": '',
          "comment": "",
          "date_sale": moment().add(1, 'day').format('YYYY-MM-DDTHH:mm:ss'),
          "glue": false,
          "edge_size": this.settings.with_edge_sizes,
          "customer_edge": false,
          "customer_material": false,
          "to_work": false,
          "draw_cut": false,
          "check_parts": false,
          "materials_list": [],
          "edge_list": [],
          "screed_list": [],
          "name_list": [],
          "items": [],
        };
        this.$store.commit('data/SET_DETAILS', []);
        this.$store.commit('data/SET_MATERIALS', []);
        this.$store.commit('data/SET_EDGES', []);
        this.$store.commit('data/SET_SCREEDS', []);
        this.$store.commit('data/SET_NAMES', []);
        this.$store.commit('data/SET_DETAIL', {});
        this.$store.commit('data/SET_ORDER', this.order);
      }
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    $('#orderModal').on('hidden.bs.modal', () => {
      if ((this.order.doc_no != '' && this.order.doc_no != null)) {
        this.clear(false)
      }
    });
    this.$root.$on('update', i => {
      this.$forceUpdate();
    });
    this.fetch1cConnection();
    this.connectionIntervalId = setInterval(this.fetch1cConnection, 5 * 60 * 1000);

  },
  beforeDestroy() {
    if (this.connectionIntervalId) {
      clearInterval(this.connectionIntervalId);
      this.connectionIntervalId = null;
    }
  }
}

</script>

<style scoped>
/* Order Actions Styles - компактный стиль */
.order-container {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 8px;
  width: 100%;
}

.order-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.actions-header {
  padding-bottom: 4px;
  border-bottom: 1px solid #dee2e6;
}

.actions-title {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 6px;
}

.actions-title i {
  color: #2c5aa0;
  font-size: 0.75rem;
}

.actions-compact {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.action-row {
  display: flex;
  gap: 6px;
  justify-content: space-between;
  width: 100%;
}

.action-row .btn-compact {
  flex: 1;
  min-width: 0;
}

/* Compact Button Styles */
.btn-compact {
  padding: 6px 10px;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: all 0.3s ease;
  min-width: 90px;
  justify-content: center;
  border: 1px solid transparent;
  line-height: 1.2;
}

.btn-compact:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-compact:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

.btn-compact i {
  font-size: 0.75rem;
}

/* Primary Button (Замовити) */
.btn-primary.btn-compact {
  background: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
}

.btn-primary.btn-compact:hover:not(:disabled) {
  background: #19469e;
  border-color: #19469e;
}

/* Info Button (Розрахунок) */
.btn-info.btn-compact {
  background: #17a2b8;
  border-color: #17a2b8;
  color: white;
}

.btn-info.btn-compact:hover:not(:disabled) {
  background: #138496;
  border-color: #138496;
}

/* Success Button (Зберегти) */
.btn-success.btn-compact {
  background: #28a745;
  border-color: #28a745;
  color: white;
}

.btn-success.btn-compact:hover:not(:disabled) {
  background: #1e7e34;
  border-color: #1e7e34;
}

/* Outline Secondary Buttons */
.btn-outline-secondary.btn-compact {
  color: #6c757d;
  border-color: #dee2e6;
  background: white;
}

.btn-outline-secondary.btn-compact:hover:not(:disabled) {
  background: #6c757d;
  border-color: #6c757d;
  color: white;
}

/* Outline Danger Button (Очистити) */
.btn-outline-danger.btn-compact {
  color: #dc3545;
  border-color: #dc3545;
  background: white;
}

.btn-outline-danger.btn-compact:hover:not(:disabled) {
  background: #dc3545;
  border-color: #dc3545;
  color: white;
}

/* Responsive design */
@media (max-width: 768px) {
  .action-row {
    flex-direction: column;
  }

  .btn-compact {
    width: 100%;
    min-width: auto;
  }
}

/* Loading state */
.order-container:has([disabled]) {
  opacity: 0.8;
}

.custom-control-label {
  color: black;
}

.connection-status {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 6px;
  background: #fff4f4;
  color: #b02a37;
  font-size: 0.85rem;
  border: 1px solid #f5c2c7;
}

.connection-status i {
  font-size: 0.9rem;
}
</style>
